module.exports = __webpack_public_path__ + "img/racoon-fairness.876aada.f0eb63cb.png";